'use strict';

angular.module('domain.advancedSearch').controller('AdvancedSearchActivity', [
	'AppService',
	'$scope',
	'$stateParams',
	function (AppService, $scope, $stateParams) {
		var AdvancedSearchActivity = this;
		var AdvancedSearch = $scope.AdvancedSearch;

		var init = function () {
			AdvancedSearch.changeSearchType(AdvancedSearch.entity.ACTIVITY, $stateParams.notificationEntityId);

			AdvancedSearch.loaded = true;
		};

		AppService.loadedPromise.then(init);
	}
]);
